import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { translate } from 'react-i18next';
import { accountRoles } from '../../../common/enums';
import { currencyFormatter } from '../../../common/utils/helpers';
import MainMenu from './MainMenu';
import SignPendingContracts from './registration-action-alert/SignPendingContracts';
import ConfirmInfoObligations from '../../loans/components/ConfirmInfoObligations';
import ConfirmLoan from '../../loans/components/ConfirmLoan';
import ConfirmLoanInsurance from '../../loans/components/ConfirmLoanInsurance';
import ConfirmPostFinancing from '../../loans/components/ConfirmPostFinancing';
//import RegistrationActionAlert from './registration-action-alert/RegistrationActionAlert';

const DashboardLayout = ({
  children,
  t,
  nameFirst,
  accountRole,
  accountBalance,
  registrationAction,
  resendActivationEmail,
  registrationDocumentsRejectReason,
  accountCreated,
  allowNewLoans,
  registrationStatus,
}) => (
  <Grid className="dashboard-wrapper">
    {accountRole !== accountRoles.EXECUTOR &&
      <Row between="xs" className="welcome-row">
        <Col xs={12} sm={accountRole === accountRoles.CREDITOR ? 5 : 12}>
          <h2>
            {t('Dobrý deň')}, {nameFirst}
          </h2>
        </Col>
        {accountRole === accountRoles.CREDITOR && (
          <Col xs={12} sm={7} className="text-right">
            <h2>
              {t('Suma na investovanie')}: {currencyFormatter(accountBalance)}
            </h2>
          </Col>
        )}
      </Row>
    }
    {accountRole === accountRoles.EXECUTOR &&
      <Row between="xs" className="welcome-row">
        <Col xs={12} sm={5}>
          <h2>
            {t('Dobrý deň, Vymáhacia spoločnosť/Ing. Karol Ruman')},
          </h2>
        </Col>
        <Col xs={12} sm={7} className="text-right">
          <h2>
            {t('Stav účtu')}: {currencyFormatter(accountBalance)}
          </h2>
        </Col>
      </Row>
    }
    <MainMenu
      accountRole={accountRole}
      registrationAction={registrationAction}
      accountCreated={accountCreated}
      allowNewLoans={allowNewLoans}
    />

    <SignPendingContracts
      registrationAction={registrationAction}
      registrationDocumentsRejectReason={registrationDocumentsRejectReason}
      accountRole={accountRole}
      resendActivationEmail={resendActivationEmail}
      registrationStatus={registrationStatus}
    />
    <ConfirmInfoObligations />
    <ConfirmLoan />
    <ConfirmLoanInsurance />
    <ConfirmPostFinancing />
    <Row>
      <Col xs={12}>{children}</Col>
    </Row>
  </Grid>
);

DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
  t: PropTypes.func.isRequired,
  nameFirst: PropTypes.string.isRequired,
  accountRole: PropTypes.string.isRequired,
  accountBalance: PropTypes.number.isRequired,
  resendActivationEmail: PropTypes.func.isRequired,
  registrationAction: PropTypes.string,
  registrationDocumentsRejectReason: PropTypes.string,
  allowNewLoans: PropTypes.bool.isRequired,
  registrationStatus: PropTypes.string,
};

export default translate()(DashboardLayout);



// WEBPACK FOOTER //
// ./src/features/dashboard/components/DashboardLayout.js